import { render, staticRenderFns } from "./TestingBg.vue?vue&type=template&id=22a459e5&scoped=true&"
import script from "./TestingBg.vue?vue&type=script&lang=js&"
export * from "./TestingBg.vue?vue&type=script&lang=js&"
import style0 from "./TestingBg.vue?vue&type=style&index=0&id=22a459e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a459e5",
  null
  
)

export default component.exports